module.exports = __webpack_public_path__ + "static/media/carta_49.54d24288.jpg";